import React from 'react';
import { uniqBy } from 'lodash';
import {
  Container,
  DeselectButton,
  SelectedIcon,
} from 'components/canvas/components/clipboard-zone-indicator/components/clipboard-zone-modal/components/selectable-node/style';
import NodePreview from 'components/node-preview';
import { color } from 'styles/settings';

function SelectableNode({ node, selectedNodes, setSelectedNodes, disabled }) {
  const isSelected = selectedNodes.find(({ id }) => id === node.id);

  function select(event) {
    if (disabled) {
      return;
    }

    event.stopPropagation();
    setSelectedNodes(uniqBy([...selectedNodes, node], 'id'));
  }

  function deselect(event) {
    event.stopPropagation();
    setSelectedNodes(selectedNodes.filter(({ id }) => node.id !== id));
  }

  return (
    <Container selected={isSelected} onClick={select} disabled={disabled}>
      <NodePreview
        node={node}
        isSelected={isSelected}
        selectedColor={color.brand.greenDark}
      />
      {isSelected && <DeselectButton onClick={deselect} />}
      {isSelected && <SelectedIcon />}
    </Container>
  );
}

export default SelectableNode;
